import classes from "./input.module.css";
import { useState, useRef } from "react";
import Hidden from "../../assets/images/Auth/passwordHidden.svg";
import Visible from "../../assets/images/Auth/passwordVisible.svg";
import LinkedIn from "../../assets/images/Onboarding/linkedin.svg";
import website from "../../assets/images/icons/website-gray.svg";
import calendar from "../../assets/images/Onboarding/calendar.svg";
import fb from "../../assets/images/Onboarding/fb.svg";
import ig from "../../assets/images/Onboarding/ig.svg";
import x from "../../assets/images/Onboarding/x.svg";
import { CheckMark } from "../../constants/svg";

const icons = {
  linkedIn: LinkedIn,
  website: website,
  calendar: calendar,
  ig: ig,
  x: x,
  fb: fb,
}

export const AuthInput = ({
  type,
  placeholder,
  value,
  onChange,
  isValid,
  text,
  label,
  name,
  id,
  icon,
  iconName = "",
  showIcon = false
}) => {
  const [valid, setValid] = useState(true);

  const hasIcon = !!(showIcon && (icon || icons[iconName]));

  const handleBlur = () => {
    if (!isValid) setValid(false);
  };

  return (
    <div className="relative">
      <label htmlFor={id}>{label}</label>
      <div className="relative flex items-center">
        {hasIcon && <img
          src={icon || icons[iconName]}
          className="absolute left-3"
          alt=""
        />}
        <input
          type={type}
          placeholder={placeholder}
          name={name}
          autoComplete={name}
          value={value}
          onChange={(e) => onChange(e)}
          onFocus={() => setValid(true)}
          onBlur={handleBlur}
          className={`input ${valid ? "" : classes.invalid} ${classes.input} ${hasIcon && "!pl-12"}`}
          id={id}
        />
      </div>
      {!valid && <span className={`t-12 ${classes.invalidText}`}>{text}</span>}
    </div>
  );
};

export const AuthInputPassword = ({
  type,
  placeholder,
  value,
  onChange,
  isValid,
  text,
  label,
  name,
  id,
  numTest,
  uppTest,
  lowTest,
  onPaste,
}) => {
  const [valid, setValid] = useState(true);
  const [hidden, setHidden] = useState(true);
  const inputRef = useRef(null);
  const handleBlur = () => {
    if (!isValid) {
      setValid(false);
    }
  };

  return (
    <div className="relative">
      <label htmlFor={id}>{label}</label>
      <div className="relative">
        <input
          ref={inputRef}
          type={type}
          placeholder={placeholder}
          name={name}
          autoComplete={name}
          value={value}
          onChange={(e) => onChange(e)}
          onFocus={() => setValid(true)}
          onBlur={handleBlur}
          className={`input ${valid ? "" : classes.invalid} ${classes.input}`}
          id={id}
          onPaste={(e) => onPaste(e)}
        />
        <img
          src={hidden ? Hidden : Visible}
          className={classes.img}
          alt=""
          onClick={() => {
            inputRef.current.type = !!hidden ? "text" : "password";
            setHidden(!hidden);
          }}
        />
      </div>
      {name === "password" && (
        <div className={`t-14 ${classes.grid} ${classes.errorGrid}`}>
          <p className={`${value?.length >= 10 ? classes.green : classes.red} flex items-center gap-1`}>
            <CheckMark /> At least 10 characters
          </p>
          <p className={`${lowTest ? classes.green : classes.red} flex items-center gap-1`}>
            <CheckMark /> 1 lowercase character
          </p>
          <p className={`${numTest ? classes.green : classes.red} flex items-center gap-1`}>
            <CheckMark /> 1 number
          </p>
          <p className={`${uppTest ? classes.green : classes.red} flex items-center gap-1`}>
            <CheckMark /> 1 symbol or uppercase character
          </p>
        </div>
      )}
      {!valid && <span className={`t-12 ${classes.invalidText}`}>{text}</span>}
    </div>
  );
};
